<template>
  <div class="d-flex flex-column flex-grow-1">
    <b-card class="flex-grow-1 text-center" v-if="items.length === 0" body-class="d-flex align-items-center justify-content-center">
      <span>Работников на смене не найдено</span>
    </b-card>
    <div class="grid-items grid-3 grid flex-grow-1" v-if="items.length > 0">
      <b-card v-for="item in paginatedData" :key="item.id">
        <slot name="item" v-bind:item="item">
          Пустой слот
        </slot>
      </b-card>
    </div>
    <b-card no-body class="controls" header-class="controls-in-slot d-flex justify-content-between align-items-center w-100">
      <template slot="header">
        <div class="switch-page d-flex align-items-center">
          <b-button
            class="mr-2"
            @click="prevPage"
            :disabled="currentPage === 0"
          >
            Предыдущая страница
          </b-button>
          <div class="pageInfo">
            <p class="mb-0">Страница {{currentPageNum}} из ({{pageCount}})</p>
          </div>
          <b-button
            class="ml-2"
            @click="nextPage"
            :disabled="currentPage > (pageCount - 2)"
          >
            Следующая страница
          </b-button>
        </div>
        <div class="other-controls ml-2">
          <slot name="controls"></slot>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'TableViewWithPagination',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      pageSize: 9,
      currentPage: 0
    }
  },
  methods: {
    nextPage () {
      this.currentPage++
    },
    prevPage () {
      this.currentPage--
    }
  },
  computed: {
    currentPageNum () {
      return this.currentPage + 1
    },
    paginatedData () {
      const start = this.currentPage * this.pageSize
      const end = start + this.pageSize
      return this.items
        .slice(start, end)
    },
    pageCount () {
      let l = this.items.length
      let s = this.pageSize
      return Math.max(Math.ceil(l / s), 1)
    }
  }
}
</script>

<style scoped>
  .grid {
    display: grid;
  }
  .grid-3 {
    grid-template-columns:  repeat(3, 1fr);
    grid-template-rows: 33.3% 33.3% 33.3%;
  }
  .controls {

  }
</style>



// WEBPACK FOOTER //
// src/components/common/TableViewWithPagination.vue